import React from 'react';
import './MatchScoreIndicator.css';

interface MatchScoreIndicatorProps {
  score: number;
  maxScore: number;
}

const MatchScoreIndicator: React.FC<MatchScoreIndicatorProps> = ({ score, maxScore }) => {
  if (score <= 0 || maxScore <= 0) return null;

  const proportion = score / maxScore;
  let level: 'high' | 'partial' | 'low';
  if (proportion >= 0.8) {
    level = 'high';
  } else if (proportion >= 0.5) {
    level = 'partial';
  } else {
    level = 'low';
  }

  return (
    <span className={`match-score-indicator ${level}`}>
      {score}/{maxScore}
    </span>
  );
};

export default MatchScoreIndicator;
